import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const buyers = [{
  name: 'Sofía',
  city: 'Mendoza',
  time: 'hace 5 min'
}, {
  name: 'Romina',
  city: 'La Plata',
  time: 'hace 12 min'
}, {
  name: 'Florencia',
  city: 'Tucumán',
  time: 'hace 23 min'
}, {
  name: 'Camila',
  city: 'Rosario',
  time: 'hace 45 min'
}, {
  name: 'Martina',
  city: 'Córdoba',
  time: 'hace 1 hora'
}, {
  name: 'Luciana',
  city: 'Buenos Aires',
  time: 'hace 2 horas'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  useEffect(() => {
    if (!isVisible) return;
    // Hide popup after 4 seconds
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
      // Schedule next popup after 15-25 seconds
      const nextDelay = Math.floor(Math.random() * 10000) + 15000;
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % buyers.length);
        setIsVisible(true);
      }, nextDelay);
    }, 4000);
    return () => clearTimeout(hideTimer);
  }, [isVisible]);
  const buyer = buyers[currentIndex];
  return <AnimatePresence data-id="element-194">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      stiffness: 400,
      damping: 25
    }} className="fixed bottom-4 left-4 sm:bottom-6 sm:left-6 z-50 bg-white rounded-xl shadow-lg border border-[#EFE3D4] p-3 sm:p-4 flex items-center gap-3 sm:gap-4 max-w-[280px] sm:max-w-sm" data-id="element-195">
          <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 bg-[#EAF6F0] rounded-full flex items-center justify-center text-xl sm:text-2xl border border-[#22C55E]/20" data-id="element-196">
            ✅
          </div>
          <div className="flex-1 min-w-0" data-id="element-197">
            <p className="text-[#3D3935] text-xs sm:text-sm font-bold truncate" data-id="element-198">
              {buyer.name} de {buyer.city}
            </p>
            <p className="text-[#8B7E76] text-[10px] sm:text-xs font-medium truncate" data-id="element-199">
              compró el Mega Pack
            </p>
            <p className="text-[#F5A04B] text-[9px] sm:text-[10px] font-bold mt-0.5" data-id="element-200">
              {buyer.time}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}